import { AsyncThunk, AsyncThunkConfig, createAsyncThunk, GetThunkAPI } from "@reduxjs/toolkit";
import { FeedCurve } from "../../Services";
import { AsyncEntityThunkConfig } from "./asyncEntityStateUtil";
import { FeedCurvesResponse, GET_FULL_FEED_CURVES } from "../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { getFarmSettingsState } from "../../Services/Agrisys_GqlDataCaller/UserCalls/dataCalls";
import { DateTime } from "luxon";

async function fetchFeedCurvesByIds(ids: number[], thunkApi:GetThunkAPI<AsyncEntityThunkConfig<FeedCurve[]>>) {
  const {getApolloClient} = thunkApi.extra;
  const state = thunkApi.getState();
  const domain = state.activeData.farm;
  const farmSettings = getFarmSettingsState(state);

  const currentTime = DateTime.now().setZone(farmSettings?.time_zone_label);
  const timezoneOffset = currentTime.offset - (currentTime.isInDST ? 60 : 0);
  
  if (!domain) {
    thunkApi.rejectWithValue([]);
  }
  try {
    const client = getApolloClient();
    const queryResponse = await client.query<FeedCurvesResponse>({query: GET_FULL_FEED_CURVES, variables: {domain, input: {ids}}, fetchPolicy: "no-cache"});
    return thunkApi.fulfillWithValue(queryResponse.data.feedCurve.info.map((feedCurve) => feedCurveConvertToLocalTime(feedCurve, timezoneOffset)))
  } catch (error) {
    return thunkApi.rejectWithValue([]);
  }
}
  
export const fetchFeedCurvesByIdsThunk = createAsyncThunk<FeedCurve[], number[], AsyncEntityThunkConfig<FeedCurve[]>>(
  `feedCurve/fetchByIds`,
  fetchFeedCurvesByIds
) satisfies AsyncThunk<FeedCurve[], number[], AsyncThunkConfig> as AsyncThunk<FeedCurve[], number[], AsyncThunkConfig>
// Explicit typing is required


// should probably just be moved to the UI but we do currently store times in redux as the local time.
function feedCurveConvertToLocalTime(feedCurve: FeedCurve, timezoneOffset: number): FeedCurve {
  return {...feedCurve, times: feedCurve.times?.map((times) => {return {...times, time: times.time + (timezoneOffset)}})}
}